/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgOracleChatOutline = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M3.6 21H3c-.6 0-1-.4-1-1V5c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H8.8c-.5 0-1 .2-1.4.6l-3.1 3.1c-.2.2-.4.3-.7.3zM4 5v13.2l2-2c.8-.8 1.8-1.2 2.8-1.2H20V5z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgOracleChatOutline as OracleChatOutline };
